import b from 'b_';
import cx from 'classnames';
import React from 'react';

import './calendar-plan-showcase__header_skeleton-view.scss';

export const CalendarPlanShowcaseHeaderSkeleton = () => {
    return (
        <div className={b('library-calendar-plan-showcase', 'header-skeleton')}>
            <div className={cx(b('skeleton', 'button'), 'skeleton-item')} />
            <div className={b('skeleton', 'title-text-wrapper')}>
                <div className={cx(b('skeleton', 'date'), 'skeleton-item')} />
                <div className={cx(b('skeleton', 'title'), 'skeleton-item')} />
            </div>
        </div>
    );
};
